import { Link, LinkProps } from '@mui/material';
import { ReactNode } from 'react';

interface SafeLinkWithFallbackProps extends Omit<LinkProps, 'href'> {
  href?: string | null;
  children: string | ReactNode;
}

export const SafeLinkWithFallback = ({ href, children, ...props }: SafeLinkWithFallbackProps) => {
  if (!href) return <>{children}</>;
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
};
